import { useEffect, useState, useRef } from "react";
import { GoogleGenerativeAI } from "@google/generative-ai";
import { RiVoiceprintLine, RiAttachment2, RiGlobalLine } from "react-icons/ri";
import { MdKeyboardVoice } from "react-icons/md";
import { BiChip } from "react-icons/bi";
import { IoArrowForward } from "react-icons/io5";
import { Link } from "react-router-dom";
// import { Tooltip } from "bootstrap";

import axios from "axios";
import AiResponseModal from "../../../components/modelpopup/AiResponseModal";
import { Tooltip } from "react-tooltip";
const promptIntro = `
  أنت مستشار ذو خبرة 30 عامًا في التحليل المالي والتحقيقات المالية. خبير عالمي في الضرائب الدولية، التكنولوجيا المالية (Fintech)، العملات الرقمية، المحاسبة والتدقيق. عملت مع الحكومات، البنوك، الشركات الكبرى، وفرق مكافحة الجرائم المالية. أنت لا ترتكب أخطاء. دقتك لا تُضاهى. اكتب الرد التالي وكأن سمعتك العالمية ومصداقيتك المهنية على المحك. لا تقدم كلامًا عامًا أو غير مدعوم — فقط تحليلات دقيقة، واقعية، ومبنية على أفضل الممارسات العالمية. 
  أجب السؤال الآتي:\n
`;

const GEMINI_API = "AIzaSyAetO_cbRT-jKsFQEdWN4W-G5AonyU3Fgk";
const OPEN_AI = process.env.REACT_APP_OPEN_AI_API_KEY;

export default function SearchBar() {
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState("");
  const [response, setResponse] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);

  const askOpenAi = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const apiUrl = "https://api.openai.com/v1/chat/completions";

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OPEN_AI}`, // Make sure OPEN_AI is defined
      };

      const requestBody = {
        model: "gpt-4",
        messages: [
          {
            role: "system",
            content: promptIntro,
          },
          {
            role: "user",
            content: input,
          },
        ],
        max_tokens: 500, // Adjust based on your need
        temperature: 0.7, // Balance between creativity and accuracy
        top_p: 1.0,
        n: 1,
      };

      const { data } = await axios.post(apiUrl, requestBody, { headers });

      setResponse(data.choices[0].message.content);
      setLoading(false);
      setShowModal(true);
    } catch (error) {
      console.error(
        "Error sending message:",
        error.response?.data || error.message
      );
    }
  };

  const handleGeminiAsking = async (e) => {
    e.preventDefault();
    if (file) askGeminiWithFiles(e);
    else askGemini(e);
  };

  const askGemini = async (e) => {
    e.preventDefault();
    const genAI = new GoogleGenerativeAI(GEMINI_API);
    setLoading(true);
    try {
      const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" }); // You can choose other models like 'gemini-pro'

      const result = await model.generateContent(`${promptIntro} ${input}`);
      // console.log(result);
      const textResponse = await result.response.text();
      setResponse(textResponse);
      setShowModal(true);
    } catch (err) {
      console.error("Error calling Gemini API:", err);
    } finally {
      setLoading(false);
    }
  };

  const askGeminiWithFiles = async (e) => {
    e.preventDefault();
    const genAI = new GoogleGenerativeAI(GEMINI_API);
    setLoading(true);
    try {
      const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" }); // You can choose other models like 'gemini-pro'
      const parts = [{ text: `${promptIntro} ${input}` }];

      if (file) {
        const base64Data = await readFileAsBase64(file);
        parts.push({
          inlineData: {
            mimeType: file.type,
            data: base64Data.split(",")[1], // Extract the base64 payload
          },
        });
      }
      const result = await model.generateContent({
        contents: [{ role: "user", parts }],
      });
      const textResponse = await result.response.text();
      setResponse(textResponse);
      setShowModal(true);
    } catch (err) {
      console.error("Error calling Gemini API:", err);
    } finally {
      setLoading(false);
      setFile(null);
    }
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleAddFile = () => {
    const inputFile = document.createElement("input");
    inputFile.type = "file";
    inputFile.accept = "image/*,application/pdf";

    inputFile.onchange = () => {
      const selectedFile = inputFile.files?.[0];
      if (selectedFile) {
        console.log("Selected file:", selectedFile.name);
        setFile(selectedFile);
      }
    };

    inputFile.click();
  };

  useEffect(() => {
    if (response) console.log("response is: ");
  }, [response]);

  const reset = () => {
    setInput("");
    setFile(null);
    setResponse("");
    setShowModal(false);
    setLoading(false);
  };

  return (
    <div className="row">
      <h1 className="ai-title">
        <span>Mass AI</span>
      </h1>
      <div
        className={
          loading
            ? "loading-opacity col-sm-12 col-md-12"
            : "col-sm-12 col-md-12"
        }
      >
        <div className="d-flex justify-content-center  mt-3 search-component ">
          <form className="w-100" onSubmit={handleGeminiAsking}>
            <div className="search-box">
              <input
                type="text"
                className="form-control border-0 search-bar-input text-white"
                placeholder="اسأل Mass..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
              />
              <div className="d-flex  gap-2 mt-3 search-bar-div">
                <div className="d-flex gap-2 search-bar-btns flex-row-reverse">
                  <Link
                    to="#"
                    className="active"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Enter"
                    onClick={handleGeminiAsking}
                  >
                    <IoArrowForward size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Voice Mode"
                  >
                    <RiVoiceprintLine size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Dictation"
                  >
                    <MdKeyboardVoice size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Attach files"
                    onClick={handleAddFile}
                  >
                    <RiAttachment2 size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Set sources for research"
                  >
                    <RiGlobalLine size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Choose a model"
                  >
                    <BiChip size={20} />
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {loading ? (
        <div className="col-lg-6 mt-4 " dir="ltr">
          <div className="d-flex flex-row gap-2 bold  justify-content-center">
            Analyzing ...
            <div className="spinner-border text-primary" role="status" />
          </div>
        </div>
      ) : (
        <AiResponseModal
          show={showModal}
          // onClose={() => setShowModal(false)}
          onClose={() => (setShowModal(false), reset())}
          Name="Mass AI"
          content={response}
          question={input}
        />
      )}
      <Tooltip id="shared-tooltip" place="top" className="my-tooltip-custom" />
    </div>
  );
}
